export enum PlacementType {
    Direct = 'Direct',
    Wholesaler = 'Wholesaler',
    Carrier = 'Carrier',
}
